<template>
  <div>
    <div
      :class="{
        'd-flex justify-content-center mb-3 loading-spinner-wrapper': loading,
        'd-none': !loading
      }"
      class=" "
    >
      <b-spinner variant="primary" label="Loading..."></b-spinner>
    </div>
    <div v-show="!loading">
      <div
        class="bg-white p-2 pt-3 pb-3 d-flex align-items-top page-header"
        style="padding-bottom:0;border-bottom: 1px solid rgb(222, 226, 230);"
      >
        <div class="col">
          <div>
            <h4>{{ record ? record.Ordinal + ' ' + record.DisplayName : '' }}</h4>
          </div>
          <div class="text-uppercase text-secondary">
            <small>Budgetzuweisungen</small>
            <div class="row mt-3">
              <div class="col col-3">
                <label class="text-muted d-block mb-1"><small>Teilbudget KKE</small></label>
                <div class="bg-light p-1">
                  {{ formatCurrency(record.Budget) }}
                </div>
              </div>
              <div class="col col-1">&nbsp;</div>
              <div class="col col-3">
                <label class="text-muted d-block mb-1"><small>Zugewiesen</small></label>
                <div class="bg-light p-1">
                  {{ formatCurrency(record.BudgetAllocated) }}
                </div>
              </div>
              <div class="col col-1">&nbsp;</div>
              <div class="col col-3">
                <label class="text-muted d-block mb-1"><small>Restbudget</small></label>
                <div class="bg-light p-1">
                  {{ formatCurrency(record.BudgetSaldo) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->

          <b-button size="sm" variant="light" class="ml-2">
            <b-icon @click="refreshFormData" icon="arrow-repeat" variant="dark" class=""></b-icon>
          </b-button>
          <b-button size="sm" variant="white" class="ml-2" to="/budget">
            <b-icon @click="refreshFormData" icon="x" variant="dark" class=""></b-icon>
          </b-button>
        </div>
      </div>
      <div class="mt-3">
        <b-nav tabs class="pl-3">
          <b-nav-item :to="{ name: 'KKE Budget', params: $router.currentRoute.params }">
            Budget
          </b-nav-item>
          <!--
        --></b-nav>
      </div>
      <div class="main-canvas bg-white" style="height: calc( 100vh - 265px);">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import CostGroupsService from '@/service/CostGroupsService';
import settingsStore from '@/store/Settings';
import AppState from '@/store/App.js';
export default {
  data() {
    return {
      settingsStore,
      record: {
        Budget: 0
      },
      loading: true
    };
  },
  methods: {
    refreshFormData() {
      CostGroupsService.getCostGroupById(this.$route.params.id)
        .then(record => {
          this.record = record;
          document.title = this.record.Ordinal + ' ' + this.record.DisplayName + ' - ' + process.env.VUE_APP_NAME;
        })
        .catch(err => this.$showError(this, err.toString()))
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
          this.loading = false;
        });
    },
    formatCurrency(number) {
      if (!number) return this.$utils.numberToCurrency(0.0, settingsStore.settings['Centbetraege']);
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    }
  },
  activated() {
    this.loading = true;
    this.refreshFormData();
    AppState.isLoading = false;
  },
  mounted() {
    const that = this;
    this.$eventBus.$on('budget:changed', function() {
      that.refreshFormData();
    });
  }
};
</script>

<style scoped></style>
